import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    Button, List, ListItem, ListItemText, Typography,
} from '@material-ui/core';

import * as ProgramStore from '../../../app/store/ProgramStore';
import { timestamp } from '../../../youwell-common/dateUtils';

const styles = theme => ({
    root: {
        background: theme.palette.common.white,
        marginTop: theme.spacing(4),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    previous: {
        width: '50%',
        padding: theme.spacing(2),
    },
    list: {
        maxHeight: 300,
        overflow: 'auto',
        background: theme.palette.grey[50],
    },
    buttonContainer: {
        width: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: {
        margin: theme.spacing(4, 2),
        minWidth: 120,
    },
});

const useStyles = makeStyles(theme => styles(theme), { name: 'WorkSheet' });

const WorkSheet = ({
    task, currentForm, taskContentRef,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const translate = useSelector(state => getTranslate(state.localize));
    // const responsesForCurrentTask = useSelector(state => state.programStore.currentProgramTaskResponses?.[task.patientProgramElementId]?.[task.id]);
    const forms = useSelector(state => state.programStore.allForms?.[task.patientProgramElementId]?.[task.id]);

    React.useEffect(() => {
        if (task.isWorkSheet && !forms) {
            dispatch(ProgramStore.actionCreators.getResponseForms({ requestParams: { patientProgramElementId: task.patientProgramElementId, taskId: task.id } }));
        }
    }, [dispatch, forms, task.id, task.isWorkSheet, task.patientProgramElementId]);

    const addNewForm = () => {
        if (currentForm.submitted) {
            dispatch(ProgramStore.actionCreators.setCurrentForm(task.patientProgramElementId, task.id, null));
        } else {
            const currentSubmittedForm = {
                ...currentForm,
                submitted: new Date(),
            };
            taskContentRef.current.submitForm(() => {
                dispatch(ProgramStore.actionCreators.updateAllFormsList(task.patientProgramElementId, task.id, currentSubmittedForm));
                dispatch(ProgramStore.actionCreators.setCurrentForm(task.patientProgramElementId, task.id, null));
            })
        }
    }

    const selectForm = form => () => {
        dispatch(ProgramStore.actionCreators.setCurrentForm(task.patientProgramElementId, task.id, form));
    }

    return (
        <div className={classes.root}>
            {forms?.length > 0 && (
                <div className={classes.previous}>
                    <Typography variant="subtitle1">
                        {translate('worksheet.previous')}
                    </Typography>
                    <List className={classes.list}>
                        {forms.map(r => (
                            <ListItem key={r.formId} button onClick={selectForm(r)} selected={r.formId === currentForm?.formId}>
                                <ListItemText primary={r.submitted ? timestamp(r.submitted, translate) : translate('worksheet.current')} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            )}

            <div className={classes.buttonContainer}>
                <Button className={classes.button} variant="contained" color="primary" onClick={addNewForm} disabled={!currentForm}>
                    {currentForm?.submitted ? translate('worksheet.newForm') : translate('worksheet.send')}
                </Button>
            </div>
        </div>
    );
};

WorkSheet.propTypes = {
    task: PropTypes.object.isRequired,
    currentForm: PropTypes.object,
    taskContentRef: PropTypes.object,
};

WorkSheet.defaultProps = {
    currentForm: null,
    taskContentRef: null,
};

export default WorkSheet;
